import React from 'react'
import styled from 'styled-components'
import { colors } from '../../healtheraComponents'

const DoctorInfo = ({ firstName, lastName, address: { line1, line2, city, postalCode } }) => {
  return (
    <Info>
      {`Ordered by ${firstName} ${lastName}`}
      <br />
      -
      <br />
      {line1}
      <br />
      {line2}
      <br />
      {city}
      <br />
      {postalCode}
      <br />
    </Info>
  )
}

export default DoctorInfo

export const Info = styled.div`
  color: ${colors.GRAY};
  font-size: 15px;
`
